import { Route, createBrowserRouter, createRoutesFromElements } from "react-router";

import { RootLayout } from "@/components/layouts/root-layout";

import { RootErrorBoundary } from "@/components/features/error-boundary";

import { SelectHotelTemplatePage } from "@/components/pages/[hotelID]/select-hotel-template/page";
import { TopPage } from "@/components/pages/page";
import { SetupPage } from "@/components/pages/setup-page";

import { AuthGuard } from "./_guard";
import { PATHS } from "./paths";
import { AuthRoute, HotelRoute, HotelRouteWithLayout, PolicyRoute } from "./routes/index";

export const routesFromElements = createRoutesFromElements(
	<Route element={<RootLayout />} errorElement={<RootErrorBoundary />}>
		<Route element={<AuthGuard />}>
			{/* セットアップ */}
			<Route path={PATHS.SETUP} index element={<SetupPage />} />

			<Route path={PATHS.TOP} index element={<TopPage />} />

			<Route path={PATHS.HOTEL.SELECT_HOTEL_TEMPLATE} index element={<SelectHotelTemplatePage />} />

			{HotelRouteWithLayout}
			{HotelRoute}
		</Route>

		{AuthRoute}
		{PolicyRoute}
	</Route>,
);

export const routerConfig = createBrowserRouter(routesFromElements);
